<template>
    <div>
        <div class="card">
            <div class="flex-sb" @click="fillerVisible = !fillerVisible">
                <span class="title">填写者信息组件</span>
                <Icon
                    :type="fillerVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="fillerVisible">
                <!-- <div class="card-btn" @click="menuClick(1)">
                    <img class="card-icon" src="@/assets/controlPanel/icon/title.png" />
                    <div>表单名称</div>
                </div> -->
                <!-- <div class="card-btn" @click="menuClick(20)">
                    <img class="card-icon" src="@/assets/controlPanel/icon/title.png" />
                    <div>提交按钮</div>
                </div> -->
                <div class="card-btn" @click="menuClick(18)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/fillerName.png"
                    />
                    <div>填写者姓名</div>
                </div>
                <div class="card-btn" @click="menuClick(19)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/authPhone.png"
                    />
                    <div>授权手机号</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="flex-sb" @click="basicVisible = !basicVisible">
                <span class="title">基础组件</span>
                <Icon
                    :type="basicVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(2)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/singleLineText.png"
                    />
                    <div>单行文本</div>
                </div>
                <div class="card-btn" @click="menuClick(3)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/multiLineText.png"
                    />
                    <div>多行文本</div>
                </div>
            </div>
            <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(4)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/dropDown.png"
                    />
                    <div>下拉菜单</div>
                </div>
                <div class="card-btn" @click="menuClick(5)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/switchItem.png"
                    />
                    <div>开关</div>
                </div>
            </div>
            <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(6)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/radioItem.png"
                    />
                    <div>单选框</div>
                </div>
                <div class="card-btn" @click="menuClick(7)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/checkboxItem.png"
                    />
                    <div>多选框</div>
                </div>
            </div>
            <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(8)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/phoneCode.png"
                    />
                    <div>手机验证码</div>
                </div>
                <div class="card-btn" @click="menuClick(9)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/locationItem.png"
                    />
                    <div>定位</div>
                </div>
            </div>
            <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(10)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/calendarItem.png"
                    />
                    <div>日历</div>
                </div>
                <div class="card-btn" @click="menuClick(11)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/agreementItem.png"
                    />
                    <div>协议</div>
                </div>
            </div>
            <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(12)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/tableItem.png"
                    />
                    <div>表格</div>
                </div>
                <div class="card-btn" @click="menuClick(15)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/signatureItem.png"
                    />
                    <div>手写签名</div>
                </div>
                <!-- <div class="card-btn" @click="menuClick(13)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/tableItem.png"
                    />
                    <div>自增表格</div>
                </div> -->
            </div>
            <!-- <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(22)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/crossTable.png"
                    />
                    <div>十字表格</div>
                </div>
                <div class="card-btn" @click="menuClick(14)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/checkItem.png"
                    />
                    <div>检查项</div>
                </div>
            </div> -->
            <!-- <div class="flex-sb flex-w" v-if="basicVisible">
                <div class="card-btn" @click="menuClick(15)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/signatureItem.png"
                    />
                    <div>手写签名</div>
                </div>
            </div> -->
        </div>
        <div class="card mb0">
            <div class="flex-sb" @click="mediaVisible = !mediaVisible">
                <span class="title">多媒体组件</span>
                <Icon
                    :type="mediaVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="mediaVisible">
                <div class="card-btn" @click="menuClick(16)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/uploadImage.png"
                    />
                    <div>上传图片</div>
                </div>
                <div class="card-btn" @click="menuClick(17)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/uploadVideo.png"
                    />
                    <div>上传视频</div>
                </div>
            </div>
        </div>
        <!-- <div class="card mb0">
            <div class="flex-sb" @click="mediaVisible = !mediaVisible">
                <span class="title">AI组件</span>
                <Icon
                    :type="mediaVisible ? 'ios-arrow-up' : 'ios-arrow-down'"
                    size="20"
                    color="#484E66"
                    class="c-p"
                />
            </div>
            <div class="flex-sb flex-w" v-if="mediaVisible">
                <div class="card-btn" @click="menuClick(21)">
                    <img
                        class="card-icon"
                        src="@/assets/controlPanel/icon/aiRecognition.png"
                    />
                    <div>AI识别</div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        active_id: {
            type: Number,
            default: -1,
        },
        formData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            index_id: -1,
            admin_id: "",
            // 填写者信息组件展开状态
            fillerVisible: true,
            // 基础组件展开状态
            basicVisible: true,
            // 多媒体组件展开状态
            mediaVisible: true,
        };
    },
    created() {
        try {
            this.admin_id = localStorage.getItem("admin_id") || "";
        } catch (e) {
            console.warn("localStorage 读取失败:", e);
            this.admin_id = "";
        }
    },
    methods: {
        // 左侧菜单点击
        menuClick(e) {
            this.index_id = this.formData.length;
            if (this.active_id > 0) {
                this.index_id = this.active_id + 1;
            }
            // 生成组件唯一 field_key（参照 admin_id + "a" + Date.now() 模式，加入组件类型与随机串避免重复）
            const field_key =
                this.admin_id +
                "_" +
                e +
                "_" +
                Date.now() +
                "_" +
                Math.random().toString(36).slice(2, 6);
            switch (e) {
                case 1:
                    this.formData.splice(this.index_id, 0, {
                        type: 1,
                        field_key: field_key,
                        name: "表单名称",
                        content: {
                            title: "表单名称",
                            title_size: "20",
                            title_color: "#000",
                            title_position: "center",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 2:
                    this.formData.splice(this.index_id, 0, {
                        type: 2,
                        field_key: field_key,
                        name: "单行文本",
                        content: {
                            field_attribute: "2",
                            record_result: "2",
                            preset_type: "1",
                            error_message: "错误提示",
                            error_message_size: "13",
                            error_message_color: "#f00",
                            select_style: "1",
                            title: "标题",
                            title_color: "#000",
                            border_color: "#999",
                            fill_color: "#fff",
                            prompt_text: "提示文字",
                            pre_filled_content: "",
                            prompt_text_color: "#ccc",
                            enter_text_color: "#000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 3:
                    this.formData.splice(this.index_id, 0, {
                        type: 3,
                        field_key: field_key,
                        name: "多行文本",
                        content: {
                            field_attribute: "2",
                            select_style: "1",
                            title: "标题",
                            title_color: "#000",
                            border_color: "#999",
                            fill_color: "#fff",
                            prompt_text: "提示文字",
                            pre_filled_content: "",
                            prompt_text_color: "#ccc",
                            enter_text_color: "#000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                            error_message: "错误提示",
                            error_message_size: "13",
                            error_message_color: "#f00",
                        },
                    });
                    break;
                case 4:
                    this.formData.splice(this.index_id, 0, {
                        type: 4,
                        field_key: field_key,
                        name: "下拉菜单",
                        content: {
                            field_attribute: "2",
                            option_list: [],
                            select_style: "1",
                            title: "标题",
                            title_color: "#000",
                            border_color: "#999",
                            fill_color: "#fff",
                            prompt_text_color: "#ccc",
                            enter_text_color: "#000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                            prompt_text: "提示文字",
                        },
                    });
                    break;
                case 5:
                    this.formData.splice(this.index_id, 0, {
                        type: 5,
                        field_key: field_key,
                        name: "开关",
                        content: {
                            select_style: "1",
                            title: "标题",
                            title_color: "#000",
                            initial_state: 1,
                            open_button_color: "#ff761d",
                            close_button_color: "#ccc",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 6:
                    this.formData.splice(this.index_id, 0, {
                        type: 6,
                        field_key: field_key,
                        name: "单选框",
                        content: {
                            field_attribute: "2",
                            record_result: "2",
                            title: "单选框",
                            title_color: "#000",
                            select_style: "1",
                            table_list: [
                                { name: "选项一", picview: "", value: "" },
                            ],
                            not_selected_color: "#fff",
                            selected_color: "#ff761d",
                            text_color: "#333",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                            select_style_value: "1",
                        },
                    });
                    break;
                case 7:
                    this.formData.splice(this.index_id, 0, {
                        type: 7,
                        field_key: field_key,
                        name: "多选框",
                        content: {
                            field_attribute: "2",
                            record_result: "2",
                            title: "多选框",
                            title_color: "#000",
                            select_style: "1",
                            table_list: [
                                { name: "选项一", picview: "", value: "" },
                            ],
                            not_selected_color: "#fff",
                            selected_color: "#ff761d",
                            text_color: "#333",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                            select_style_value: "1",
                        },
                    });
                    break;
                case 8:
                    this.formData.splice(this.index_id, 0, {
                        type: 8,
                        field_key: field_key,
                        name: "手机验证码",
                        content: {
                            field_attribute: "2",
                            select_style: 1,
                            title: "手机验证",
                            title_color: "#000",
                            border_color: "#999",
                            fill_color: "#fff",
                            prompt_text: "请输入手机号",
                            prompt_text_color: "#ccc",
                            enter_text_color: "#000",
                            restriction_num: "",
                            unsent_button_color: "#ff761d",
                            sent_button_color: "#ccc",
                            unsent_text_color: "#fff",
                            sent_text_color: "#fff",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 9:
                    this.formData.splice(this.index_id, 0, {
                        type: 9,
                        field_key: field_key,
                        name: "定位",
                        content: {
                            field_attribute: "2",
                            select_style: 1,
                            title: "定位",
                            title_color: "#000",
                            border_color: "#999",
                            fill_color: "#fff",
                            prompt_text: "请选择",
                            prompt_text_color: "#ccc",
                            enter_text_color: "#000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 10:
                    this.formData.splice(this.index_id, 0, {
                        type: 10,
                        field_key: field_key,
                        name: "日历",
                        content: {
                            field_attribute: "2",
                            title: "日历",
                            title_color: "#000",
                            select_color: "#fff",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                            prompt_text: "请选择",
                        },
                    });
                    break;
                case 11:
                    this.formData.splice(this.index_id, 0, {
                        type: 11,
                        field_key: field_key,
                        name: "协议",
                        content: {
                            field_attribute: "2",
                            unchecked_button_color: "#ccc",
                            checkbox_color: "#ff761d",
                            uncheck_text_color: "#666",
                            check_text_color: "#ff761d",
                            title: "服务协议",
                            title_color: "#000",
                            logic_value: "2",
                            text: "服务协议服务协议服务协议",
                            view_button_color: "#ff761d",
                            unviewed_button_color: "#d4d4d4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 6, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 12:
                    this.formData.splice(this.index_id, 0, {
                        type: 12,
                        field_key: field_key,
                        name: "表格",
                        content: {
                            field_attribute: "2",
                            title: "表格",
                            title_color: "#000",
                            border_color: "#ccc",
                            fill_color: "#fff",
                            title_background_color: "#F2F7FA",
                            table_list: [
                                { label: "姓名", value: "", type: "文本" },
                            ],
                            privacy_protection: false,
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 13:
                    this.formData.splice(this.index_id, 0, {
                        type: 13,
                        field_key: field_key,
                        name: "自增表格",
                        content: {
                            field_attribute: "2",
                            title: "自增表格",
                            title_color: "#000",
                            border_color: "#ccc",
                            fill_color: "#fff",
                            title_background_color: "#F2F7FA",
                            btn_name: "新增一组",
                            btn_text_color: "#000",
                            btn_background_color: "#F2F7FA",
                            btn_border_color: "#ccc",
                            table_list: [
                                { label: "姓名", value: "", type: "文本" },
                            ],
                            default_value: "",
                            min_value: "",
                            max_value: "",
                            privacy_protection: false,
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 14:
                    this.formData.splice(this.index_id, 0, {
                        type: 14,
                        field_key: field_key,
                        name: "检查项",
                        content: {
                            field_attribute: "2",
                            one_click_checkmark: "1",
                            title: "检查项",
                            title_color: "#000",
                            border_color: "#ccc",
                            fill_color: "#fff",
                            button_name: "一键打勾",
                            button_text_color: "#fff",
                            table_list: [
                                { value: "检查项一" },
                                { value: "检查项二" },
                            ],
                            button_set: [],
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 15:
                    this.formData.splice(this.index_id, 0, {
                        type: 15,
                        field_key: field_key,
                        name: "手写签名",
                        content: {
                            field_attribute: "2",
                            title: "手写签名",
                            privacy_protection: false,
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 16:
                    this.formData.splice(this.index_id, 0, {
                        type: 16,
                        field_key: field_key,
                        name: "上传图片",
                        content: {
                            field_attribute: "2",
                            select_style: 1,
                            minimum_upload: 1,
                            maximum_upload: 10,
                            title: "上传图片",
                            title_color: "#000",
                            fill_color: "#F2F7FA",
                            border_color: "#F2F7FA",
                            icon_background_color: "#ccc",
                            prompt_text_color: "#666",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 17:
                    this.formData.splice(this.index_id, 0, {
                        type: 17,
                        field_key: field_key,
                        name: "上传视频",
                        content: {
                            field_attribute: "2",
                            title: "上传视频",
                            title_color: "#000",
                            minimum_upload: 1,
                            maximum_upload: 10,
                            fill_color: "#F2F7FA",
                            border_color: "#F2F7FA",
                            icon_background_color: "#ccc",
                            prompt_text_color: "#666",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 18:
                    this.formData.splice(this.index_id, 0, {
                        type: 18,
                        field_key: field_key,
                        name: "填写者姓名",
                        content: {
                            field_attribute: "2",
                            privacy_protection: false,
                            error_message: "错误提示",
                            error_message_size: "13",
                            error_message_color: "#f00",
                            select_style: 1,
                            title: "姓名",
                            title_color: "#000",
                            border_color: "#999",
                            fill_color: "#fff",
                            prompt_text: "请输入姓名",
                            pre_filled_content: "",
                            prompt_text_color: "#ccc",
                            enter_text_color: "#000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 19:
                    this.formData.splice(this.index_id, 0, {
                        type: 19,
                        field_key: field_key,
                        name: "授权手机号",
                        content: {
                            field_attribute: "2",
                            privacy_protection: false,
                            error_message: "错误提示",
                            error_message_size: "13",
                            error_message_color: "#f00",
                            select_style: 1,
                            title: "手机号",
                            title_color: "#000",
                            border_color: "#999",
                            fill_color: "#fff",
                            prompt_text: "请输入手机号",
                            pre_filled_content: "",
                            prompt_text_color: "#ccc",
                            enter_text_color: "#000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 20:
                    this.formData.splice(this.index_id, 0, {
                        type: 20,
                        field_key: field_key,
                        name: "提交按钮",
                        content: {
                            title: "提交",
                            title_color: "#fff",
                            border_color: "#FF761D",
                            button_submit_color: "#FF761D",
                            cannot_submit_border_color: "#666",
                            button_cannot_submit_color: "#666",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 12, left: 12 },
                            inner_spacing: { top: 6, left: 0 },
                            rounded_corner_setting: { top: 20, bottom: 20 },
                        },
                    });
                    break;
                case 21:
                    this.formData.splice(this.index_id, 0, {
                        type: 21,
                        field_key: field_key,
                        name: "AI识别",
                        content: {
                            field_attribute: "2",
                            image_source: ["1", "2"],
                            title: "自定义",
                            title_color: "#000",
                            border_color: "#ccc",
                            fill_color: "#fff",
                            title_background_color: "#F2F7FA",
                            table_list: [{ label: "字段", value: "" }],
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 22:
                    this.formData.splice(this.index_id, 0, {
                        type: 22,
                        field_key: field_key,
                        name: "十字表格",
                        content: {
                            field_attribute: "2",
                            title: "十字表格",
                            title_color: "#000",
                            border_color: "#ccc",
                            fill_color: "#fff",
                            title_background_color: "#F2F7FA",
                            table_list: [
                                { label: "姓名", value: "", type: "文本" },
                            ],
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: {
                                value: "",
                                picview: "",
                            },
                            outer_spacing: { top: 0, left: 0 },
                            inner_spacing: { top: 12, left: 12 },
                            rounded_corner_setting: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                default:
                    console.log("FORM");
                    break;
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 12px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
}
.flex-w {
    flex-wrap: wrap;
}
.card-btn,
.card-btn-none {
    padding-left: 12px;
    margin: 6px 0;
    width: 130px;
    height: 42px;
    background: #ffffff;
    border: 1px solid #dce5eb;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.card-btn-none {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #484e66;
}
.c-p {
    cursor: pointer;
}
.card-icon {
    margin-right: 6px;
    width: 18px;
    height: 18px;
}
</style>